export default {
  "report.list.head.title": "イベントレポート一覧 | LINK-J",
  "report.list.head.title.suffix": " | イベントレポート | LINK-J",
  "report.list.head.description":
    "LINK-Jが主催したイベントの開催レポートを掲載しています。イベント当日の様子や講演内容をご覧いただけます。",
  "report.list.title": "イベントレポート",
  "report.list.category.main": "LINK-J主催・共催",
  "report.list.category.coSponsorship": "LINK-J協賛・協力",
  "report.list.category.memberEvent": "特別会員開催",
  "report.list.category.attend": "出展・参加",
  "report.list.category.all": "イベントレポート一覧",

  // BBT
  "report.bbt.list.head.title": "レポート一覧（BBT） | LINK-J",
  "report.bbt.list.head.description":
    "創薬・医療領域のスタートアップ支援・コミュニティ活性化｜Blockbuster TOKYO レポート",
  "report.bbt.list.title": "レポート",
  "report.bbt.list.category.all": "レポート一覧",

  // Detail
  "report.header": "イベントレポート",
  "report.bbt.header": "レポート",
  "report.eventPdf.title": "イベントPDF",
} as const;
